import type { FC, SVGProps } from 'react'

export const CashCrossed: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_382_11536)">
      <g clipPath="url(#clip1_382_11536)">
        <path
          d="M7.99992 14.6666C11.6818 14.6666 14.6666 11.6819 14.6666 7.99998C14.6666 4.31808 11.6818 1.33331 7.99992 1.33331C4.31802 1.33331 1.33325 4.31808 1.33325 7.99998C1.33325 11.6819 4.31802 14.6666 7.99992 14.6666Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M8 3V4" stroke="currentColor" strokeLinecap="round" />
        <path d="M8 13V12" stroke="currentColor" strokeLinecap="round" />
        <path d="M5.5 10.5L10.5 5.5" stroke="currentColor" strokeLinecap="round" />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 3.5C7.42571 3.5 6.79785 3.6426 6.30491 4.05339C5.79592 4.47754 5.5 5.12976 5.5 6C5.5 6.78992 5.8297 7.33623 6.31465 7.72015C6.75173 8.06617 7.31452 8.27707 7.78816 8.45457L7.82444 8.46816L7.82468 8.46826L8.59909 7.69384C8.46646 7.64085 8.33609 7.59199 8.21184 7.54543L8.17556 7.53184C7.65651 7.33719 7.23705 7.17495 6.93535 6.9361C6.6703 6.72627 6.5 6.46008 6.5 6C6.5 5.37024 6.70408 5.02246 6.94509 4.82161C7.20215 4.6074 7.57429 4.5 8 4.5C8.4129 4.5 8.69479 4.60237 8.8646 4.69209C8.95072 4.73759 9.01037 4.78113 9.04496 4.80934C9.06224 4.82343 9.07317 4.83363 9.0779 4.83819L9.0797 4.83995C9.08344 4.84399 9.08723 4.84795 9.09107 4.85183L9.79835 4.14455C9.79121 4.13719 9.78261 4.12856 9.77254 4.11884C9.74895 4.09606 9.7172 4.06719 9.67701 4.03441C9.59666 3.96887 9.48222 3.88741 9.33175 3.80791C9.02838 3.64763 8.5871 3.5 8 3.5ZM9.53677 8.17039L8.81223 8.89492C8.90377 8.94749 8.98801 9.00322 9.06465 9.0639C9.3297 9.27373 9.5 9.53992 9.5 10C9.5 10.5974 9.29915 10.95 9.05085 11.1614C8.78899 11.3844 8.41486 11.5 8 11.5C7.59633 11.5 7.30401 11.389 7.11743 11.2855C7.02321 11.2333 6.95511 11.1824 6.91344 11.1478C6.89267 11.1305 6.8787 11.1175 6.8716 11.1106L6.86657 11.1056L6.85925 11.0979L6.15197 11.8051C6.15855 11.8119 6.16632 11.8196 6.17528 11.8283C6.19942 11.8517 6.23233 11.882 6.27406 11.9167C6.35739 11.986 6.47679 12.0737 6.63257 12.1601C6.94599 12.3339 7.40367 12.5 8 12.5C8.58514 12.5 9.21101 12.3384 9.69915 11.9228C10.2009 11.4956 10.5 10.8482 10.5 10C10.5 9.21008 10.1703 8.66377 9.68535 8.27985C9.63725 8.24177 9.58763 8.20533 9.53677 8.17039Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_382_11536">
        <rect width="16" height="16" fill="white" />
      </clipPath>
      <clipPath id="clip1_382_11536">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
